module.exports = __webpack_public_path__ + "media/images/icon-map-8e87d19170629e20d0ebcc1fa035ca6e.svg";